import Image1 from "../../assets/testimonial1.jpg";
import Image2 from "../../assets/testimonial2.jpg";
import Image3 from "../../assets/testimonial3.jpg";

export const Data = [
  {
    id: 1,
    image: Image1,
    title: "Jon Doe",
    description:
      "A really good job, all aspects of the projects were followed step by step and with good results.",
  },
  {
    id: 2,
    image: Image2,
    title: "Harry Clinton",
    description:
      "A really good job, all aspects of the projects were followed step by step and with good results.",
  },
  {
    id: 3,
    image: Image3,
    title: "Sara Cill",
    description:
      "A really good job, all aspects of the projects were followed step by step and with good results.",
  },
];
